export default {
    title: 'Overtime Request',
    cannotGetLineId: 'Cannot get line user id',
    startDate: 'Start Date',
    endDate: 'End Date',
    startTime: 'Start OT Time',
    otTime: 'OT Hours/Day',
    reason: 'Reason',
    reasonPlaceholder: 'Explanation of the overtime work to be completed.',
    formTitle: 'Inquiry',
    totalReqHrsLabel: 'Total request hours',
    hr: 'hr',
    hrs: 'hrs',
    overlapLocal: 'This period overlap with others in this request',
    startDateOverlap: 'Start date must be before end date',
    endDateOverlap: 'End date must be after start date',
    requestSuccess: 'Overtime request submitted',
    employeeName: 'name',
    employeeNo: 'employee no',
    date: 'date',
    approvalInquiry: 'Approval Inquiry',
    back: 'back',
    totalInquiry: 'Total inquiry'
}
